import PropTypes from 'prop-types';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import { jsx as _jsx } from "react/jsx-runtime";
const TileMessageThumbnail = ({
  children
}) => /*#__PURE__*/_jsx(UIMediaLeft, {
  children: children
});
TileMessageThumbnail.displayName = 'TileMessageThumbnail';
TileMessageThumbnail.propTypes = {
  children: PropTypes.node.isRequired
};
export default TileMessageThumbnail;